"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCurrentLocation = void 0;
// @ts-nocheck
const react_1 = require("react");
const useCurrentLocation = () => {
    const [location, setLocation] = react_1.useState(null);
    const successLocation = (position) => {
        setLocation(position.coords);
    };
    const errorLocation = () => { };
    react_1.useEffect(() => {
        return navigator.geolocation.getCurrentPosition(successLocation, errorLocation, { enableHighAccuracy: true });
    }, []);
    return location;
};
exports.useCurrentLocation = useCurrentLocation;
//# sourceMappingURL=useCurrentLocation.js.map